import Constants from 'expo-constants';
import { Platform } from 'react-native';

import { AppEndpoint } from '~/contexts/app-config';

/**
 * App runs natively on a device
 */
export const isNative = () => {
    return Platform.OS !== 'web';
};

/**
 * App runs in a web browser
 */
export const isWeb = () => {
    return Platform.OS === 'web';
};

/**
 * Running on production or staging like environment
 */
export const isProductionOrStaging = () => {
    const profile: AppEndpoint = Constants.expoConfig?.extra?.profile;

    return ['production', 'staging', 'prod', 'dev'].includes(profile);
};
